<div class="igntr-theme flex-1 bg-[var(--background-color)]">
  <div
    class="max-w-[1180px] mx-auto px-[16px] py-[16px] md:px-[40px] md:py-[24px]"
  >
    @if (document) {
      <app-document-editform
        [editedDocument]="document"
      ></app-document-editform>
    } @else {
      <app-spinner></app-spinner>
    }
  </div>
</div>
